import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { DataProcessingGroupByStatusProps } from '../../../types/reduxTypes/dataProcessingGroupByStatus';

const createReducer = <T extends SliceCaseReducers<DataProcessingGroupByStatusProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDataProcessingGroupByStatusData(state, action) {
    state.dataProcessingGroupByStatusData = action.payload;
  }
});

export default reducers;
